import { AxiosResponse } from "axios"
import axios from "./kindeRequest"
import { KindeUserProfile } from "types/kinde.types"

/**
 * Fetches the user profile information from Kinde.
 *
 * @param accessToken - The access token for authorization.
 * @returns Promise resolving to the user profile data.
 * @throws Will throw an error if the request fails.
 */
export const fetchUser = async (
  accessToken: string
): Promise<KindeUserProfile> => {
  const res: AxiosResponse<KindeUserProfile> = await axios.get(
    "https://sequence.kinde.com/oauth2/user_profile",
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  )

  return res.data
}
